import React from 'react'
import { useSelector } from 'react-redux'
import { Route, Switch, useRouteMatch, useParams } from 'react-router-dom'

import usePermissions from './usePermissions'

import RechargesHistoryContainer from '~/balance/containers/RechargesHistoryContainer'
import { Brand, useBrand } from '~/brand'
import { CustomerPageContainer } from '~/customer'
import EnergyContractPageContainer from '~/energyContract/containers/EnergyContractPageContainer'
import { selectFeatureFlag, Flags } from '~/featureFlags'
import { OffersConfiguratorContainer } from '~/offersConfigurator'
import { PATHS } from '~/pages/router/paths'
import { SubscriptionContainer } from '~/subscriptionDetail'

interface ParamsProps {
  productId?: string
}

const SubscriptionContainerWrapper: React.FC = () => {
  const { productId }: ParamsProps = useParams()

  return <SubscriptionContainer productId={productId || ''} />
}

const MainRoutes: React.FC = () => {
  const match = useRouteMatch()
  const { hasPermissionsToAccessRoute } = usePermissions()
  const { brand } = useBrand()
  const isEnergyContractsActiveFlag = useSelector(selectFeatureFlag(Flags.isEnergyContractsActive))

  return (
    <Switch>
      <Route exact path={[`${match.path}`]}>
        {hasPermissionsToAccessRoute(PATHS.CUSTOMER) && <CustomerPageContainer />}
      </Route>

      <Route exact path={`${match.path}/${PATHS.ENERGY}`}>
        {isEnergyContractsActiveFlag &&
          hasPermissionsToAccessRoute(PATHS.ENERGY) &&
          brand === Brand.masmovil && <EnergyContractPageContainer />}
      </Route>

      <Route exact path={`${match.path}/${PATHS.PRODUCT}/:productId`}>
        {hasPermissionsToAccessRoute(PATHS.PRODUCT) && <SubscriptionContainerWrapper />}
      </Route>

      <Route path={`${match.path}/${PATHS.PRODUCT}/:productId/recharges`}>
        {hasPermissionsToAccessRoute(PATHS.RECHARGES) && <RechargesHistoryContainer />}
      </Route>

      <Route
        exact
        path={[
          `${match.path}/${PATHS.OFFERS_CONFIGURATOR}`,
          `${match.path}/${PATHS.OFFERS_CONFIGURATOR}/:accountNumber`,
        ]}
      >
        {hasPermissionsToAccessRoute(PATHS.OFFERS_CONFIGURATOR) && <OffersConfiguratorContainer />}
      </Route>
    </Switch>
  )
}

export default MainRoutes
